import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  Paper,
  Rating,
  Switch,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import Constants from "../../../data/Constants";
import { AiOutlineOrderedList } from "react-icons/ai";
import { getUserOrders } from "services/order.service";
import OrderItem from "components/OrderItem";

function Order(props) {
  const [data, setData] = useState();
  const { id } = useParams();

  const { setProgress, setToast } = useOutletContext();

  useEffect(() => {
    async function api() {
      try {
        setProgress(true);
        const res = await getUserOrders(id);
        if (res) {
          setData(res);
          setProgress(false);
        } else {
          // error
          setToast({ error: true, message: Constants.Error.UNKNOWN });
          setProgress(false);
        }
      } catch (error) {
        // error
        console.log(error);
        setToast({ error: true, message: Constants.Error.UNKNOWN });
        setProgress(false);
      }
    }
    if (id) {
      api();
    }
  }, []);

  return (
    data && (
      <div>
        <h1 className="text-xl font-extrabold flex gap-2 items-center">
          {" "}
          <AiOutlineOrderedList size={32} /> User Orders{" "}
          {data[0]
            ? data[0].createdBy.firstname
              ? "for " +
                data[0].createdBy.firstname +
                " " +
                data[0].createdBy.lastname
              : data[0].createdBy._id
            : ""}
        </h1>

        <div className="flex flex-col gap-4 py-4 flex-wrap">
          {data.length == 0 && (
            <div className="py-5 text-gray-600"> No Orders Yet </div>
          )}

          {data.map((item) => {
            return <OrderItem item={item} />;
          })}
        </div>
      </div>
    )
  );
}

export default Order;
